import React, { Fragment } from 'react';
import { func } from 'prop-types';
import { Page } from '../../components';
import context from '../../serverContext';

const ConfirmCoBorrower = props => {
  const titleText = `Do you want to continue applying with ${context.previousSecondaryBorrower.firstName} ${context.previousSecondaryBorrower.lastName}?`;
  const headerText = `Great! Let's grab ${context.previousSecondaryBorrower.firstName}'s information.`;

  const handleAddNewCoBorrower = addNewCoBorrower => {
    props.onIncomeAdditionalClick({ addNewCoBorrower }, () => {
      props.saveValues({});
      props.nextLocation();
    });
  };

  const pageTitle = <div className="confirm-coborrower__titleHeader confirm-coborrower__title">{titleText}</div>;
  const pageHeader = (
    <Fragment>
      <div className="confirm-coborrower__titleHeader">{headerText}</div>
      <div className="confirm-coborrower__newCoborrower">
        <a role="link" tabIndex="0" onClick={() => handleAddNewCoBorrower(true)}>
          Applying with someone else?
        </a>
      </div>
    </Fragment>
  );

  return (
    <Page
      title={pageTitle}
      header={pageHeader}
      goBack={props.previousLocation}
      submitHandler={() => handleAddNewCoBorrower(false)}
      name="confirmCoBorrower"
    >
      <div className="confirm-coborrower__content">
        <div className="confirm-coborrower__groupIcon" />
      </div>
    </Page>
  );
};

ConfirmCoBorrower.propTypes = {
  previousLocation: func.isRequired,
  nextLocation: func.isRequired,
  onIncomeAdditionalClick: func.isRequired,
  saveValues: func.isRequired,
};

export default ConfirmCoBorrower;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pages/ConfirmCoBorrower/ConfirmCoBorrower.scss');